import React, { useContext,useEffect,useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import "./Leftmenu.scss";
import { ThemeContext } from "../../context/ThemeContext";
import { AuthContext } from "../../context/AuthContext";
import { UserRolesEnum} from "../../enum/enums";

const Leftmenu = () => {
  const { showMenu } = useContext(ThemeContext);
  const { user } = useContext(AuthContext);
  const [hasDashboardPageRights, setDashboardPageRights] = useState(false);
  const [hasUserAdminPageRights, setUserAdminPageRights] = useState(false);
  const [hasGeneralSettingsPageRights, setGeneralSettingsPageRights] = useState(false);
  const [hasUserManagementPageRights, setUserManagementPageRights] = useState(false); 
  const [hasReportPageRights, setReportPageRights] = useState(false); 
  const fetchData = async () => {
    const userRoleValue = user?.userRole;
    switch (userRoleValue) {
      case UserRolesEnum.SUPER_ADMIN:
        setDashboardPageRights(true);
        setUserAdminPageRights(true);
        setGeneralSettingsPageRights(true);
        setUserManagementPageRights(true);     
        setReportPageRights(true);
        break; 
      case UserRolesEnum.ADMIN:
        setDashboardPageRights(true);
        setUserAdminPageRights(true);
        setGeneralSettingsPageRights(true);
        setUserManagementPageRights(true);     
        setReportPageRights(true);
        break;
      case UserRolesEnum.SUPERVISOR:
        setDashboardPageRights(true);
        setUserAdminPageRights(true);
        setGeneralSettingsPageRights(false);
        setUserManagementPageRights(false);   
        setReportPageRights(true);  
        break;
      case UserRolesEnum.TECHINICIAN:
        setDashboardPageRights(false);
        setUserAdminPageRights(true);
        setGeneralSettingsPageRights(false);
        setUserManagementPageRights(false);   
        setReportPageRights(false);  
        break;
      default:
        setUserAdminPageRights(false);
        setGeneralSettingsPageRights(false);
        setUserManagementPageRights(false); 
        setDashboardPageRights(false);
        setReportPageRights(false);
    }
  };
  useEffect(() => {  
    fetchData();
  },[]);
  return (
    <div className={showMenu ? "left-menu-area show" : "left-menu-area hide"}>
      <div className="logo-area">
        <img className="menu-logo" src={logo} alt="" />
      </div>
      <div className="menus-area">
        <ul className="menu-ul">
          {hasDashboardPageRights && (
          <li className="menu-li">            
            <NavLink activeclassname="active" to="/dashboard">
              <div className="zea-icons dashboard"></div>
            </NavLink>
          </li>
          )}
          {hasUserAdminPageRights && (
            <li className="menu-li">
              <NavLink activeclassname="active" to="/techniciandashbaord">
                <div className="zea-icons menu1"></div>
              </NavLink>
            </li>
          )}
          
          
          {hasUserManagementPageRights && (
            <li className="menu-li">
              <NavLink activeclassname="active" to="/usermanagement">
                <div className="zea-icons usericon"></div>
              </NavLink>
            </li>
          )}  
          
          
          {hasGeneralSettingsPageRights && (
            <li className="menu-li">
              <NavLink activeclassname="active" to="/generalsettings">
                <div className="zea-icons settingsicon"></div>
              </NavLink>
            </li>
          )}

          {hasReportPageRights && (
            <li className="menu-li">
              <NavLink activeclassname="active" to="/report">
                <div className="zea-icons reportIcon"></div>
              </NavLink>
            </li>
          )}
          
        </ul>
      </div>
    </div>
  );
};

export default Leftmenu;
